import React, { useEffect, useState } from 'react';

// Helpers & Utils
import useUserAccess from '../../hooks/useUserAccess';
import { useMainLayoutContext } from 'modules/Layouts/MainLayout/MainLayoutContext';

// Components
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import TransferTemplatesTable from '../../modules/Transfers/Templates/TransferTemplatesTable';
import AddTransferTemplateButton from '../../modules/Transfers/Templates/AddTransferTemplateButton';

const TransferTemplates = () => {
  const [updateTableTrigger, updateTable] = useState({});
  const [hasCreateTemplateAccess] = useUserAccess([
    'Transfers_TransferTemplates_Create',
  ]);
  const { setPageLayoutOptions, clearContext } = useMainLayoutContext();

  useEffect(() => {
    if (hasCreateTemplateAccess) {
      setPageLayoutOptions((prev) => ({
        ...prev,
        extra: () => (
          <AddTransferTemplateButton onAdd={() => updateTable({})} />
        ),
      }));
    }

    return () => clearContext();
  }, [hasCreateTemplateAccess, clearContext, setPageLayoutOptions]);

  return (
    <PageContentCard>
      <TransferTemplatesTable updateTableTrigger={updateTableTrigger} />
    </PageContentCard>
  );
};

export default TransferTemplates;
